import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { OpsAuditTimeline } from '../../_shared/components/OpsAuditTimeline';
export function OpsAuditPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(OpsAuditTimeline, {
            defaultObjectType: "delivery.programs",
            defaultObjectId: programId
        })
    });
}
